import { Box } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { ThirdPartyReviews } from '~/components/third-party-reviews';
import { trackEvent } from '~/features/analytics/track-event';
import { TestimonialCarousel } from '~/features/experiments/ab_plp_redesign_2025/components/testimonials-carousel';
import { homepageTestimonials } from '~/features/experiments/ab_plp_redesign_2025/models/homepage-testimonials';
import { ThirdPartyReviewContentList } from '~/features/third-party-reviews/model';

export function PlansSocialProofSection({ thirdPartyReviews }: { thirdPartyReviews: ThirdPartyReviewContentList }) {
  return (
    <Box as='section' bgColor='grey.50' mt={{ base: -2, md: -4 }} pb={{ base: 14, md: 28 }} pt={0}>
      <TestimonialCarousel testimonials={homepageTestimonials} />
      {thirdPartyReviews.length > 0 && (
        <ContentContainer contentMaxWidth='content-max-width-md' mt={{ base: 12, lg: 16 }}>
          <Box
            bgColor='white'
            border='1px solid'
            borderColor='#f2f2f2'
            borderRadius='8px'
            px={{ base: '16px', lg: '40px' }}
            py={{ base: '40px', lg: '48px' }}
          >
            <ThirdPartyReviews
              listProps={{ justifyContent: 'space-around' }}
              reviews={thirdPartyReviews}
              customLinkLabel={(review) =>
                review.reviewCount != null ? `${review.reviewCount.toLocaleString()} Reviews` : 'Read reviews'
              }
              onLinkClick={(_e, review) =>
                trackEvent({
                  name: 'Plans CTA Clicked',
                  type: 'click',
                  label: 'plans_review_clicked',
                  value: review.company.name,
                })
              }
            />
          </Box>
        </ContentContainer>
      )}
    </Box>
  );
}
